import _ from 'lodash'

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Tabs of one page look like list and detail (the first tab is one level up), but each tab
  // has its own columns, so each starts from its own order and page.
  const tabsPage = to.matched.find((record) => record.meta.independentTabs)
  if (tabsPage && from.matched.includes(tabsPage)) {
    return
  }

  const fromSessions = useSessionStorage<string | undefined>(from.path, undefined)
  const toSessions = useSessionStorage<string | undefined>(to.path, undefined)

  if (!_.isEmpty(toSessions.value) && to.path !== from.path) {
    to.query = JSON.parse(toSessions.value!)
    toSessions.value = undefined
    return navigateTo(to)
  }

  if (to.path.split('/').length > from.path.split('/').length && !_.isEmpty(from.query)) {
    fromSessions.value = JSON.stringify(from.query)
  }

  return
})
